module.exports = __webpack_public_path__ + "Roboto-Medium.4d9f3f9e5195e7b074bb.eot";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Medium.eot
// module id = 232
// module chunks = 2